export default {
  groups: [],
  group: {},
  student: {},
  users: {},
  userForms: {},
  taskProgress: 0,
  forms: [],
  tasks: [],
  tickets: [],
  importUsers: [],
  fetchingUsers: false
}
